<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.edit" | translate}} {{"admin.countries.country" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendEditionRequest()" [formGroup]="countryEditForm">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.country" | translate}} {{"admin.countries.code" | translate}}</mat-label>
          <input [formControl]="codeControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.country" | translate}}</mat-label>
          <input [formControl]="nameControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.region" | translate}}</mat-label>
          <mat-select [formControl]="regionControl">
            <mat-option value=""> - </mat-option>
            <mat-option *ngFor="let region of regions" [value]="region.value">{{region.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <h2>{{"admin.countries.country" |translate}} {{"admin.countries.coordinators" |translate}}</h2>

        <div class="table-container">
          <table mat-table [dataSource]="countryCoordinators" matSort>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'admin.countries.name' |translate}}</th>
              <td mat-cell *matCellDef="let country">{{country.name}}</td>
            </ng-container>

            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'admin.countries.first-name' |translate}}</th>
              <td mat-cell *matCellDef="let country">{{country.firstName}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          </table>

          <mat-paginator color="primary" [length]="totalElements"
                         [pageSize]="pageSize"
                         (page)="onPageChange($event)"
                         [pageSizeOptions]="pageSizes">
          </mat-paginator>
        </div>

        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="countryEditForm.invalid" mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
